import { queryOptions } from '@tanstack/react-query';

import {
  getEnrollments,
  getEnrollmentsDefaultParams,
} from '../actions/getEnrollments';

export const getEnrollmentsQueryOptions = ({
  offset = getEnrollmentsDefaultParams.offset,
  limit = getEnrollmentsDefaultParams.limit,
  sort = getEnrollmentsDefaultParams.sort,
  orderBy = getEnrollmentsDefaultParams.orderBy,
  search = getEnrollmentsDefaultParams.search,
  filter = getEnrollmentsDefaultParams.filter,
}: {
  offset?: string;
  limit?: string;
  sort?: string;
  orderBy?: string;
  search?: string;
  filter?: string;
} = {}) =>
  queryOptions({
    queryKey: ['enrollments', { offset, limit, sort, orderBy, search, filter }],
    queryFn: () =>
      getEnrollments({
        data: { offset, limit, sort, orderBy, search, filter },
      }),
  });
